import { ImageOverlay } from "../models/Post";

/**
 * Apply an image replacement to an existing image overlay.
 *
 * The renderer (RemotionImageOverlay) paints `sourceColor` INSTEAD of the
 * image whenever it is set, so a stale color from a swatch/scrim overlay must
 * be dropped when a real image is swapped in. Opacity is reset alongside it:
 * the old value tinted the color swatch, not the incoming image. Plain
 * image-to-image swaps preserve opacity and everything else.
 */
export function applyOverlayImageReplacement(
  overlay: ImageOverlay,
  updates: Partial<ImageOverlay> & { filePath: string }
): ImageOverlay {
  const next: ImageOverlay = { ...overlay, ...updates };
  if (overlay.sourceColor) {
    delete next.sourceColor;
    next.opacity = 100;
  }
  return next;
}
